module.exports = __webpack_public_path__ + "img/star-filled-yellow.8fcfc944.svg";